import IPaginatedParams from '@models/paginated-params';
import { getCities } from '@services/cityServices';
import { useQuery } from '@tanstack/react-query';

export const useCities = (limit: number, page: number, query: string) => {
  const enabled = query.length > 2;
  const params: IPaginatedParams = { limit, page, query };
  return useQuery({
    queryKey: ['cities', limit, page, query],
    queryFn: () => getCities(params),
    enabled,
    refetchOnWindowFocus: false,
  });
};
